import { Supervisor, EmployeeTimeSheet } from "../interfaces/V2Interface";
import client from './client';

export const getSupervisorsForPayPeriod = async (
  payPeriodID: number
): Promise<Supervisor[]> => {
  try {
    const response = await client.get(`/admin/timesheets/payrollApproved/supervisorList?payPeriodID=${payPeriodID}`);

    if (!response.data) {
      throw new Error('No supervisor data received from server');
    }

    return response.data as Supervisor[];
  } catch (error) {
    console.error('Error fetching supervisors:', error);
    throw error;
  }
};

export const getPayrollApprovedTimesheets = async (
  supervisorID: number,
  payPeriodID: number
): Promise<EmployeeTimeSheet[]> => {
  try {
    const response = await client.get(`/admin/timesheets/payrollApproved?payPeriodID=${payPeriodID}&supervisorID=${supervisorID}`);

    if (!response.data) {
      throw new Error('No timesheet data received from server');
    }

    if (!Array.isArray(response.data)) {
      throw new Error('Invalid timesheet data format received');
    }

    return response.data as EmployeeTimeSheet[];
  } catch (error) {
    console.error(
      `Error fetching timesheets for supervisor ${supervisorID}, period ${payPeriodID}:`,
      error
    );
    throw error;
  }
};

export const generateWCDPBatchExport = async (
  supervisorID: number,
  payPeriodID: number,
): Promise<{ batchID: string; batchID_DD: string }> => {
  try {
    const response = await client.get(`/admin/timesheets/generateWCDPBatchExport?supervisorID=${supervisorID}&payPeriodID=${payPeriodID}`);

    if (!response.data) {
      throw new Error('No batch report data received');
    }
    
    return response.data as { batchID: string; batchID_DD: string };
  } catch (error) {
    console.error('Error fetching batch reports:', error);
    throw error;
  }
};

export const generateWCDPBatchExportForEmployees = async (
  supervisorID: number,
  payPeriodID: number,
  altEmployeeIDs: string[]
): Promise<{ batchID: string; batchID_DD: string }> => {
  try {

    const params = {altEmployeeIDs, supervisorID, payPeriodID};
    const response = await client.post(`/admin/timesheets/generateWCDPBatchExportForEmployees`, params);

    if (!response.data) {
      throw new Error('No batch report data received');
    }
    
    return response.data as { batchID: string; batchID_DD: string };
  } catch (error) {
    console.error('Error fetching batch reports:', error);
    throw error;
  }
};

